import { BaseService, RequestType } from "@intech/react-service";
import { DependenteEntidade } from "../entidades/DependenteEntidade";

class Dependente extends BaseService {

  constructor() {
    super("dependente");
  }

  Buscar = () => this.CreateRequest<Array<DependenteEntidade>>(RequestType.GET);
}

export const DependenteService = new Dependente();